(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["group-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
    function initAutoScrollForCarousel(container) {
      // 防止重复初始化
      if (container._groupCarouselAutoScrollInitialized) return;
      container._groupCarouselAutoScrollInitialized = true;

      var autoScrollAttr = container.getAttribute('data-auto-scroll');
      if (!(autoScrollAttr === 'true' || autoScrollAttr === '1')) {
        return;
      }

      var viewport = container.querySelector('.group-carousel__viewport');
      var track = container.querySelector('.group-carousel__track');
      if (!viewport || !track) return;

      var slides = track.children;
      if (!slides || slides.length <= 1) return; // 一张卡就没必要自动滚

      var intervalSec = parseFloat(container.getAttribute('data-auto-scroll-interval') || '4');
      if (isNaN(intervalSec) || intervalSec <= 0) intervalSec = 4;
      var interval = intervalSec * 1000;

      var slidePositions = [];
      var maxScrollLeft = 0;
      var currentIndex = 0;
      var pausedAtEnd = false; // 是否已经在最后一屏“暂停过一轮”

      function computePositions() {
        slidePositions = [];
        maxScrollLeft = Math.max(0, track.scrollWidth - viewport.clientWidth);

        // 如果没有横向滚动空间，就不启用自动轮播
        if (maxScrollLeft <= 0) {
          slidePositions = [];
          return;
        }

        for (var i = 0; i < slides.length; i++) {
          slidePositions.push(slides[i].offsetLeft);
        }
      }

      computePositions();
      if (!slidePositions.length) {
        return; // 没可滚动空间，直接退出
      }

      viewport.scrollLeft = slidePositions[0];

      var timer;

      function step() {
        // 如果这个 block 已经被移出 DOM，就清理定时器
        if (!document.body.contains(container)) {
          clearInterval(timer);
          if (container._groupCarouselResizeObserver) {
            container._groupCarouselResizeObserver.disconnect();
          }
          window.removeEventListener('resize', computePositions);
          return;
        }

        // 如果因为响应式变化导致之前的计算失效，重新计算
        if (!slidePositions.length || maxScrollLeft <= 0) {
          computePositions();
          if (!slidePositions.length || maxScrollLeft <= 0) {
            return;
          }
        }

        var scrollLeft = viewport.scrollLeft;
        var atEnd = Math.abs(scrollLeft - maxScrollLeft) < 2; // 接近最右端视为“末尾”

        // —— 末尾逻辑：先停一轮，再回到第 1 屏 ——
        if (atEnd) {
          if (!pausedAtEnd) {
            // 第一次到达末尾：记录一次暂停，这一轮什么都不动
            pausedAtEnd = true;
            return;
          } else {
            // 第二次轮到末尾：回到第 1 屏，并清除暂停状态
            pausedAtEnd = false;
            currentIndex = 0;

            var targetStart = slidePositions[0];
            if (viewport.scrollTo) {
              viewport.scrollTo({
                left: targetStart,
                behavior: 'smooth'
              });
            } else {
              viewport.scrollLeft = targetStart;
            }
            return;
          }
        }

        // —— 非末尾：根据当前 scrollLeft 找最近的 slide，向后移动一张 ——
        var closestIndex = 0;
        var minDiff = Math.abs(slidePositions[0] - scrollLeft);

        for (var i = 1; i < slidePositions.length; i++) {
          var diff = Math.abs(slidePositions[i] - scrollLeft);
          if (diff < minDiff) {
            minDiff = diff;
            closestIndex = i;
          }
        }

        currentIndex = closestIndex + 1;
        if (currentIndex >= slidePositions.length) {
          currentIndex = slidePositions.length - 1;
        }

        var target = slidePositions[currentIndex];

        // 目标不要超过最大可滚动值，否则会追一个“到不了”的位置
        if (target > maxScrollLeft) {
          target = maxScrollLeft;
        }

        if (viewport.scrollTo) {
          viewport.scrollTo({
            left: target,
            behavior: 'smooth'
          });
        } else {
          viewport.scrollLeft = target;
        }
      }

      timer = setInterval(step, interval);
      container._groupCarouselAutoScrollTimer = timer;

      // 监听尺寸变化，重新计算 slide 位置（防止响应式宽度改变）
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function() {
          computePositions();
        });
        ro.observe(track);
        container._groupCarouselResizeObserver = ro;
      } else {
        window.addEventListener('resize', computePositions);
      }
    }

    function initAllGroupCarousels(root) {
      var scope = root || document;
      var containers = scope.querySelectorAll('.group-carousel-block');
      if (!containers || !containers.length) return;

      for (var i = 0; i < containers.length; i++) {
        initAutoScrollForCarousel(containers[i]);
      }
    }

    document.addEventListener('DOMContentLoaded', function() {
      initAllGroupCarousels();
    });

    document.addEventListener('shopify:section:load', function(event) {
      initAllGroupCarousels(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
